/**
 * НАЗНАЧЕНИЕ: Кастомный хук для автоматического обновления статуса слайдов
 * ОПИСАНИЕ: Реализует множественный опрос слайдов с различными условиями:
 * - Опрос слайдов без DZI (каждые 15 сек) - отслеживание конвертации
 * - Опрос слайдов в ИИ-обработке (каждые 15 сек) - отслеживание анализа
 * ОПТИМИЗАЦИЯ: Автоматическая очистка таймеров, мемоизация функций
 * ИСПОЛЬЗОВАНИЕ: В TableWithPagination для real-time обновлений
 * БЕЗОПАСНОСТЬ: Защита от утечек памяти через cleanup функции
 */
import { useEffect } from 'react';
import { createSlidePollingEffect } from '../utils/slidePolling.js';

/**
 * Хук для множественного опроса слайдов с разными условиями
 * 
 * @param {Array} slides - Массив слайдов для проверки
 * @param {Function} dispatch - Redux dispatch функция
 * @param {Function} fetchSlideById - Действие для получения слайда по ID
 * @param {Array} configs - Массив конфигураций для опроса:
 *   - filter: функция фильтрации слайдов
 *   - interval: интервал проверки в миллисекундах
 *   - logPrefix: префикс для логирования
 */
export const useMultiSlidePolling = (slides, dispatch, fetchSlideById, configs) => {
    useEffect(() => {
        // Создаем функции опроса для каждой конфигурации
        const cleanupFunctions = configs.map(config => 
            createSlidePollingEffect(
                slides,
                config.filter,
                dispatch,
                fetchSlideById,
                config.interval,
                config.logPrefix
            )
        );

        // Возвращаем функцию очистки, которая отменяет все таймеры
        return () => {
            cleanupFunctions.forEach(cleanup => cleanup());
        };
    }, [slides, dispatch, fetchSlideById, configs]);
};
